import { GameFont } from "by/gamefactory/cityversetycoon/scenes/common/GameFont";
import { FullBuildingTooltip } from "by/gamefactory/cityversetycoon/scenes/common/components/FullBuildingTooltip";
import { HBox } from "by/gamefactory/cityversetycoon/scenes/common/components/ui/HBox";
import { CommonResourcesPackage } from "by/gamefactory/cityversetycoon/scenes/common/resources/CommonResourcesPackage";
import { Container, IDestroyOptions, Sprite, Text, TextStyle } from "pixi.js";
import { PiggyMultiplier } from "../../../../common/components/PiggyMultiplier";

export class WalletFullBuildingDescription extends HBox {
    private readonly commonResources: CommonResourcesPackage;

    private tooltip: FullBuildingTooltip;

    private piggyContainer: Container;
    private piggyIcon: PiggyMultiplier;
    private piggyText: Text;

    private visitContaier: Container;
    private visitIcon: Sprite;
    private visitText: Text;

    private costPerSqftContainer: Container;
    private costPerSqftIcon: Sprite;
    private costPerSqftText: Text;

    private sqftContainer: Container;
    private sqftIcon: Sprite;
    private sqftText: Text;

    public constructor(commonResources: CommonResourcesPackage) {
        super(52);
        this.commonResources = commonResources;
        this.build();
    }

    private build(): void {
        this.piggyContainer = new Container();
        this.piggyContainer.on("pointerdown", () => this.showTooltipByClick("PIGGY BOOSTER,\nEXCLUSIVE TO BUILDING OWNERS", 1, true));
        this.piggyContainer.eventMode = "static";
        this.piggyIcon = new PiggyMultiplier(this.commonResources);
        this.piggyIcon.position.y = -16;
        this.piggyIcon.scale.set(0.8);
        this.piggyText = new Text("1.00", new FloorTextStyle());
        this.piggyText.position.x = this.piggyIcon.width + 5;
        this.piggyContainer.addChild(this.piggyIcon, this.piggyText);

        this.visitContaier = new Container();
        this.visitContaier.on("pointerdown", () => this.showTooltipByClick("MAXIMUM NUMBER OF GAME COINS PER VISIT", 2, true));
        this.visitContaier.eventMode = "static";
        this.visitIcon = new Sprite(this.commonResources.assets_common_ui_substract_icon_png);
        this.visitIcon.position.y = -6;
        this.visitText = new Text("1,000", new CrownsTextStyle());
        this.visitText.position.x = this.visitIcon.width + 7.9;
        this.visitContaier.addChild(this.visitIcon, this.visitText);

        this.costPerSqftContainer = new Container();
        this.costPerSqftContainer.on("pointerdown", () => this.showTooltipByClick("COST PER SQUARE FEET IN USD", 3));
        this.costPerSqftContainer.eventMode = "static";
        this.costPerSqftIcon = new Sprite(this.commonResources.assets_common_ui_box_dollar_icon_png);
        this.costPerSqftIcon.position.y = -6;
        this.costPerSqftText = new Text("0,25", new FloorTextStyle());
        this.costPerSqftText.position.x = this.costPerSqftIcon.width + 7.12;
        this.costPerSqftContainer.addChild(this.costPerSqftIcon, this.costPerSqftText);

        this.sqftContainer = new Container();
        this.sqftContainer.on("pointerdown", () => this.showTooltipByClick("TOTAL SQUARE FEET IN THE BUILDING", 4));
        this.sqftContainer.eventMode = "static";
        this.sqftIcon = new Sprite(this.commonResources.assets_common_ui_box_icon_png);
        this.sqftIcon.position.y = -6;
        this.sqftText = new Text("6,520", new FloorTextStyle());
        this.sqftText.position.x = this.sqftIcon.width + 8.44;
        this.sqftContainer.addChild(this.sqftIcon, this.sqftText);

        this.tooltip = new FullBuildingTooltip(this.commonResources);

        this.addChild(
            this.piggyContainer,
            this.visitContaier,
            this.costPerSqftContainer,
            this.sqftContainer,
            this.tooltip
        );
    }

    private async showTooltipByClick(tooltipText: string, itemNumber: number, needChangeColor?: boolean): Promise<void> {
        if (!this.tooltip.visible) {
            await this.tooltip.hideHint();
        }
        if (needChangeColor) {
            this.tooltip.changeTooltipTextColor("#ffc700");
        }
        this.tooltip.position.set(345, -110);
        this.tooltip.showHint(tooltipText, itemNumber);
    }

    public updateDescription(piggyValue: number, visitText: string, costPerSqftText: string, sqftText: string): void {
        this.piggyText.text = `+${Math.round((piggyValue - 1) * 100)}%`;
        this.visitText.text = visitText;
        this.costPerSqftText.text = costPerSqftText;
        this.sqftText.text = sqftText;
        this.alignmentStrategy();
        this.piggyContainer.alpha = piggyValue != 1 ? 1 : 0;
        this.piggyContainer.eventMode = piggyValue != 1 ? "static" : "none";
    }

    public async hideTooltip(): Promise<void> {
        await this.tooltip.hideHint();
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.visitIcon.off("pointerdown");
        this.visitText.off("pointerdown");
        this.piggyIcon.off("pointerdown");
        this.piggyText.off("pointerdown");
        this.costPerSqftIcon.off("pointerdown");
        this.costPerSqftText.off("pointerdown");
        this.sqftIcon.off("pointerdown");
        this.sqftText.off("pointerdown");
        super.destroy(options);
    }
}

class FloorTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            align: "center",
            fill: "#ffffff",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 42
        }));
    }
}

class CrownsTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            align: "center",
            fill: "#ffc700",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 42
        }));
    }
}
